export const SidebarVariant = Object.freeze({
  PROP1: "PROP1",       
  PROP2: "PROP2",       
  PROP3: "PROP3", 
});
